
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from './local';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ja', // デフォルト言語を日本語に設定
    fallbackLng: 'ja', // フォールバック言語も日本語に設定
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
